var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.data,"hide-default-footer":"","disable-pagination":""},scopedSlots:_vm._u([{key:"item.title",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":"/data/view"}},[_vm._v(_vm._s(item.title))])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }